import { Button, Menu, MenuItem, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ProjectDetailContext,
  EDialogType,
} from "./Interfaces/ProjectDetailInterfaces";

// icon
import Icon from "../Icon";
import ChevronRight from "../../../images/icons/neutral_edit/Chevron Right.svg";
import Q3DIconButton from "../Parts/Q3DIconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";

type Props = {};

const OverflowMenu = (props: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { updateCurrentDialog } = useContext(ProjectDetailContext);
  const { t } = useTranslation();

  /*****************************************
  state
 ******************************************/

  /*****************************************
  function
 ******************************************/
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickDownloadOpen = () => {
    updateCurrentDialog(EDialogType.EXPORT_DATA);
    setAnchorEl(null);
  };

  const handleClickProjectDelete = () => {
    updateCurrentDialog(EDialogType.PROJECT_DELETE);
    setAnchorEl(null);
  };

  const handleClickProjectDetailOpen = () => {
    updateCurrentDialog(EDialogType.PROJECT_DETAIL);
    setAnchorEl(null);
  };

  const handleSettingDialogOpen = () => {
    updateCurrentDialog(EDialogType.SETTING);
    setAnchorEl(null);
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customBackground = {
    background: theme.palette.base.menu,
  };

  const RightIcon = () => {
    return (
      <div
        style={{
          height: "24px",
          width: "24px",
          right: "6px",
          position: "absolute",
        }}
      >
        <Icon imagePath={ChevronRight} color={customColor.color} />
      </div>
    );
  };

  return (
    <>
      <Q3DIconButton
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          console.log(e.target);
          setAnchorEl(e.currentTarget);
        }}
        icon={<MoreVertIcon />}
        height={"36px"}
        width={"36px"}
        disabledBorder={true}
      />
      <Menu
        id="simple-menu"
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ borderRadius: "0px" }}
        PaperProps={{
          style: {
            ...customBackground,
            ...customColor,
            display: "inline-block",
            textAlign: "center",
            borderRadius: "0px",
            minWidth: "180px",
            maxWidth: "300px",
            padding: "0px",
          },
        }}
      >
        <MenuItem onClick={handleClickDownloadOpen} className="overflow7">
          {t("EXPORT")}
          <RightIcon />
        </MenuItem>
        <MenuItem onClick={handleSettingDialogOpen} className="overflow7">
          {t("SETTING")}
          <RightIcon />
        </MenuItem>
        <MenuItem onClick={handleClickProjectDetailOpen} className="overflow7">
          {t("MORE_INFOR")}
          <RightIcon />
        </MenuItem>
        <MenuItem onClick={handleClickProjectDelete} className="overflow11">
          {t("REMOVE")}
          <RightIcon />
        </MenuItem>
      </Menu>
    </>
  );
};

export default OverflowMenu;
